import { Component } from '@angular/core';
import { KeyValue } from '@angular/common';
import { MessageService } from '@dexio/common';
import { ProjectsService } from '../../services/projects.service';

@Component({
  selector: 'app-home',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  messages: Array<any> = [];
  projects: Array<any> = [];
  projectsStats: Array<any> = [];
  userStats: Map<string, any[]> = new Map<string, any[]>();

  constructor(
    private readonly projectService: ProjectsService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.messageService.getMessages()
      .subscribe({
        next: (_: Array<any>) => {
          this.messages = _;
        }
      });
    this.projectService.getProjects()
      .subscribe({
        next: (_: Array<any>) => {
          this.projects = _;
          this.projects.forEach((proj:any) =>{
            this.projectService.getStatistics(proj.id).subscribe((stats: any) => {
              stats.stats = stats.stats.filter((stat:any) => !stat.name.includes('Level'));
              stats.stats = stats.stats.sort((a:any,b:any) => {
                return (b.name.includes("Project") - (a.name.includes("Project"))) ||
                  (b.name.includes("Indexing") - (a.name.includes("Indexing"))) ||
                  (b.name.includes("Certification") - (a.name.includes("Certification"))) ||
                  (b.name.includes("Error") - (a.name.includes("Error"))) ||
                  (b.name.includes("Suppressed") - (a.name.includes("Suppressed"))) ||
                  (b.name.includes("Completed") - (a.name.includes("Completed"))) ||
                  b.name.localeCompare(a.name);
              });
              var existingIndex = this.projectsStats.findIndex(exist => exist.id == proj.id);
              if (existingIndex > -1) { this.projectsStats.splice(existingIndex, 1); }
              this.projectsStats.push({id: proj.id, name: proj.name, stats: stats.stats});
            });
          });
        }
      });
    this.projectService.getAllUserStatistics().subscribe((stats: any) => {
      var formattedStats: Map<string, any[]> = new Map<string, any[]>();
      stats.forEach((stat: any) => {
        if (stat.name == 'Total') { return; }
        if (stat.name.split('|').length > 1) {
          if(!formattedStats.get(stat.name.split('|')[1])) { formattedStats.set(stat.name.split('|')[1], []); }
          formattedStats.get(stat.name.split('|')[1])?.push(stat);
        }
      });
      this.userStats = formattedStats;
    });
    this.projectService.refreshProjects();
  }

  specificOrder = (a: KeyValue<string,any[]>, b: KeyValue<string,any[]>) => {
    return ((b.key.includes("Indexing") ? 1 : 0) - (a.key.includes("Indexing") ? 1 : 0)) || b.key.localeCompare(a.key);
  }
}
